export default __webpack_public_path__ + "static/media/NFLGamePreview.1153ec99.png";